var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7311 0H4.26889C1.91384 0 0 1.91384 0 4.26889V22.7311C0 25.0862 1.91384 27 4.26889 27H22.7311C25.0862 27 27 25.0862 27 22.7311V4.26889C27 1.91957 25.0804 0 22.7311 0ZM25.4529 22.7311C25.4529 24.2324 24.2324 25.4529 22.7311 25.4529H4.26889C2.76761 25.4529 1.54711 24.2324 1.54711 22.7311V4.26889C1.54711 2.76761 2.76761 1.54711 4.26889 1.54711H22.7311C24.2324 1.54711 25.4529 2.76761 25.4529 4.26889V22.7311Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2504 8.91576C15.9468 8.61207 15.4597 8.61207 15.156 8.91576C14.8523 9.21945 14.8523 9.7065 15.156 10.0102L17.8778 12.732H7.25427C6.82452 12.732 6.48071 13.0758 6.48071 13.5055C6.48071 13.9353 6.82452 14.2791 7.25427 14.2791H17.8778L15.1617 16.9951C14.858 17.2988 14.858 17.7859 15.1617 18.0896C15.3107 18.2386 15.5113 18.3188 15.7061 18.3188C15.9009 18.3188 16.1015 18.2443 16.2504 18.0896L20.2901 14.0499C20.5938 13.7462 20.5938 13.2591 20.2901 12.9554L16.2504 8.91576Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowSquare);
export default __webpack_public_path__ + "static/media/icon-arrow-square.0fdf7d747d0bcc8b0879c8ee95ad4c30.svg";
export { ForwardRef as ReactComponent };